import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { TestimonialsHero } from '../components/testimonials/TestimonialsHero';
import { FeaturedTestimonial } from '../components/testimonials/FeaturedTestimonial';
import { TestimonialsGrid } from '../components/testimonials/TestimonialsGrid';
import { GoogleReviewsHighlight } from '../components/testimonials/GoogleReviewsHighlight';
import { TestimonialsCTA } from '../components/testimonials/TestimonialsCTA';
export function TestimonialsPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2644">
      <Navigation data-id="element-2645" />
      <main data-id="element-2646">
        <TestimonialsHero data-id="element-2647" />
        <FeaturedTestimonial data-id="element-2648" />
        <TestimonialsGrid data-id="element-2649" />
        <GoogleReviewsHighlight data-id="element-2650" />
        <TestimonialsCTA data-id="element-2651" />
      </main>
      <Footer data-id="element-2652" />
    </div>;
}